import React from "react";
import PropTypes from "prop-types";
import { OptionsHeader } from "../OptionsHeader";
import {
  ErrorCountBlock,
  HexagonCard,
  FullWidthCard,
} from "@learningblocks/storybook-components";
import { OptionsListing, Option } from "../OptionsListing";
import { SlideOneOption } from "../SlideOneOption";
import { SlideThreeOption } from "../SlideThreeOption";
import { OptionsDescription } from "./OptionsDescription";
import "./style.scss";
import { Utilities } from "@learningblocks/exp-constants";

const { COMPONENT_TYPE } = Utilities;

export function OptionsBlock(props) {
  const getOptionType = () => {
    let type = "";
    if (props.optionsList.length) {
      type = props.optionsList[0].type;
    }
    return type;
  };

  const optionType = getOptionType();

  const setAsNextStep = (optionId) => {
    props.setAsNextStep({ optionId, type: props.type });
  };

  const composeOption = (optionNode) =>
    React.createElement(Option, {
      optionId: NaN,
      type: "",
      setAsNextStep,
      optionNode: React.createElement(optionNode, {}),
    });

  const cloneOption = (optionNode) =>
    React.createElement(Option, {
      optionId: NaN,
      type: "",
      setAsNextStep,
      optionNode: React.cloneElement(optionNode, {}),
    });

  const setOption = () => {
    switch (optionType) {
      case COMPONENT_TYPE.SLIDE_ONE_OPTION:
        return composeOption(SlideOneOption);
      case COMPONENT_TYPE.SLIDE_THREE_OPTION:
        return composeOption(SlideThreeOption);
      case COMPONENT_TYPE.FULL_WIDTH_CARD:
        return props.overrides.FULL_WIDTH_CARD
          ? cloneOption(props.overrides.FULL_WIDTH_CARD)
          : composeOption(FullWidthCard);
      // return composeOption(FullWidthCard);
      case COMPONENT_TYPE.LINK_HEXAGON_MODAL:
        return props.overrides.HEXAGON_CARD
          ? cloneOption(props.overrides.HEXAGON_CARD)
          : composeOption(HexagonCard);
      // return composeOption(HexagonCard);
      default:
        return <></>;
    }
  };

  return (
    <div className="designOptions">
      <OptionsHeader optionsTitle={props.optionsTitle}>
        <ErrorCountBlock
          incorrects={props.incorrects}
          maxIncorrects={props.maxIncorrects}
        />
      </OptionsHeader>
      <div className="designOptions--body">
        <OptionsDescription message={props.optionsDescription} />
        <OptionsListing
          option={setOption()}
          optionsList={props.optionsList}
          optionType={optionType}
          overrides={props.overrides}
        />
      </div>
    </div>
  );
}

OptionsBlock.propTypes = {
  /**
   * Maximum possible incorrects for the slide
   */
  maxIncorrects: PropTypes.number,
  /**
   * Number of incorrects committed so far
   */
  incorrects: PropTypes.number,
  /**
   * Title to be displayed on the Option Header
   */
  optionsTitle: PropTypes.string,
  /**
   * List of options avaliable for the operation
   */
  optionsList: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, type: PropTypes.string })
  ),
  /**
   * Function to invoke when SetAsNextSlide step button is clicked
   */
  setAsNextStep: PropTypes.func,
  /**
   * Operation description message to be displayed on top of
   * options list.
   */
  optionsDescription: PropTypes.string,
  /**
   * Type is used to check the type of current design slide
   */
  type: PropTypes.oneOf([
    "DESIGN_SLIDE_TWO",
    "DESIGN_SLIDE_THREE",
    "DESIGN_SLIDE_ONE",
  ]),
  /**
   * Override component that is rendered
   */
  overrides: PropTypes.object,
};

OptionsBlock.defaultProps = {
  optionsDescription: "",
  optionsList: [],
  optionsTitle: "",
  overrides: {},
};
